import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  grid: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    marginTop: 0,
  },

  fieldHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing(1),

    '& svg': {
      cursor: 'pointer',
      marginLeft: theme.spacing(1),
    },
  },

  groupContainer: {
    paddingLeft: theme.spacing(2),
  },
}));
